import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=b2dc0954&scoped=true"
import script from "./ReportForm.vue?vue&type=script&lang=js"
export * from "./ReportForm.vue?vue&type=script&lang=js"
import style0 from "./ReportForm.vue?vue&type=style&index=0&id=b2dc0954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dc0954",
  null
  
)

export default component.exports